import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { IProps, ILoadedProps } from './interfaces';

export const path = '*';

const PageNotFound: React.FC<IProps> = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      i18n: () => import(`./ru.json`),
    },
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...props} i18n={{ ...loaded.i18n }} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageNotFound;
